import React from "react";
import { css } from "@emotion/react";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";

type Props = {
  onClick: () => void;
  loading: boolean;
};

export const CancelBizsolWaitingButton = ({ onClick, loading }: Props) => {
  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Font variant="m" component="span" css={authorityName}>
        連携待
      </Font>
      <Button
        type="button"
        variant="secondary"
        onClick={onClick}
        disabled={loading}
      >
        解除する
      </Button>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "200px",
  marginRight: "15px",
  paddingTop: "10px",
  paddingBottom: "16px",
});

const inputWrapper = css({
  width: "100%",
});

const authorityName = css({
  marginRight: "10px",
});

const authorityNameWrapper = css({
  marginTop: "10px",
});
